import Column from '@components/Column';
import Divider from '@components/Divider';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

interface Props {
    amountWon: number;
    amountLabel: string;
    totalLabel: string;
    /** 전달 시에만 '현재 잔액' 행을 표시한다. (충전 O / 구매 X) */
    currentBalance?: number;
}

function PrepaidPaymentInfo({
    amountWon, amountLabel, totalLabel, currentBalance,
}: Props) {
    const { t } = useTranslation('prepaidCard');
    const showCurrentBalance = currentBalance !== undefined;
    const total = showCurrentBalance ? currentBalance + amountWon : amountWon;

    return (
        <Wrapper>
            <Card fullWidth spacing={3}>
                <Text size='title' fontWeight='bold'>
                    {t('charge.paymentInfo')}
                </Text>
                <Row fullWidth justify='space-between'>
                    <Text size='body-short' fontWeight='regular' color={colors.textSecondary}>
                        {t('charge.paymentMethod')}
                    </Text>
                    <Text size='body-short' fontWeight='regular' color={colors.textSecondary}>
                        {t('components.chargeMethod.creditCard')}
                    </Text>
                </Row>
                {showCurrentBalance && (
                    <Row fullWidth justify='space-between'>
                        <Text size='body-short' fontWeight='regular' color={colors.textSecondary}>
                            {t('charge.currentBalance')}
                        </Text>
                        <Text size='body-short' fontWeight='regular' color={colors.textSecondary}>
                            {currentBalance.toLocaleString()}{t('currencyUnit')}
                        </Text>
                    </Row>
                )}
                <Row fullWidth justify='space-between'>
                    <Text size='body-short' fontWeight='regular' color={colors.textSecondary}>
                        {amountLabel}
                    </Text>
                    <Text size='body-short' fontWeight='regular' color={colors.textSecondary}>
                        {showCurrentBalance ? '+' : ''}
                        {amountWon.toLocaleString()}{t('currencyUnit')}
                    </Text>
                </Row>
                <Divider isThin />
                <Row fullWidth justify='space-between' align='center'>
                    <Text size='title' fontWeight='bold'>
                        {totalLabel}
                    </Text>
                    <Text size='headline' fontWeight='bold'>
                        {total.toLocaleString()}{t('currencyUnit')}
                    </Text>
                </Row>
            </Card>
        </Wrapper>
    );
}

const Wrapper = styled.section`
    padding: var(--spacing-4);
    width: 100%;
`;

const Card = styled(Column)`
    background: var(--color-white);
    border: 1px solid var(--color-gray3);
    border-radius: 12px;
    padding: 16px;
`;
export default PrepaidPaymentInfo;
